<script setup lang="ts">
import { CurrencyEuroIcon } from '@heroicons/vue/24/outline'
import { highlight } from '@/utils/highlight'
import type { OsInvoiceResult } from '@/api/omnisearchApi'

defineProps<{
  item: OsInvoiceResult
  query: string
}>()
// Pas de page dédiée facture pour l'instant
</script>

<template>
  <div class="flex items-start gap-3 px-3 py-2.5 rounded-lg text-left">
    <span class="mt-0.5 flex-shrink-0 w-8 h-8 rounded-md bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
      <CurrencyEuroIcon class="w-4 h-4 text-green-600 dark:text-green-400" />
    </span>
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium truncate text-base-content" v-html="highlight(item.name ?? '—', query)" />
      <p v-if="item.company?.name" class="text-xs text-base-content/60 truncate mt-0.5">
        {{ item.company.name }}
      </p>
    </div>
    <span class="badge badge-ghost badge-xs self-center flex-shrink-0">pas de lien</span>
  </div>
</template>
